import { css } from '@emotion/css';

export const formStyles = css`
  max-width: 61.6rem;
`;
